import { useEffect, useState } from 'react';
import Style from './SearchFilter.module.scss';

function SearchFilter({ initialValue, onSetGlobalFilter, placeholder }: Readonly<{
    initialValue?: string;
    onSetGlobalFilter: (filter: string) => void;
    placeholder: string;
}>): React.ReactElement {
    const [value, setValue] = useState<string>(initialValue ?? '');

    useEffect(() => {
        const timerId = setTimeout(() => {
            onSetGlobalFilter(value);
        }, 100);

        return () => {
            clearTimeout(timerId);
        };
    }, [value, onSetGlobalFilter]);

    return (
        <div className={Style.searchFilterWrapper}>
            <div className={Style.searchFilter}>
                <div className={Style.searchFilterIcon} />
                <div className={Style.searchInputWrapper}>
                    <input
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        className={Style.searchInput}
                        type="text"
                        autoComplete="off"
                        placeholder={placeholder}
                    />
                </div>
            </div>
        </div>
    );
}

export default SearchFilter;
